import React, { useContext, useEffect } from 'react';
import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import TeacketContext from 'src/context/TeacketContext';
import { getTicketCustomFields } from 'src/api/teacket';
import CustomFieldString from './CustomFieldString';
import CustomFieldInt from './CustomFieldInt';
import CustomFieldDateTime from './CustomFieldDateTime';
import CustomFieldNumber from './CustomFieldNumber';
import CustomFieldBool from './CustomFieldBool';
import CustomFieldSelect from './CustomFieldSelect';
import { Alert, notification } from 'antd';
import SkeletonTable from 'src/components/layout/SkeletonTable';
import NoData from 'src/components/layout/NoData';

//import PropTypes from 'prop-types';

const TicketCustomProperties = () => {
  const { currentTicket, currentTicketCustomFields, setCurrentTicketCustomFields } = useContext(TeacketContext);
  const { executeAsyncProcess } = useAsyncProcesses();

  useEffect(() => {
    if (!currentTicket) return;
    loadData();
  }, [currentTicket]);

  const loadData = async () => {
    await executeAsyncProcess(async () => {
      try {
        const result = await getTicketCustomFields(currentTicket.id);
        setCurrentTicketCustomFields(result);
      } catch (error) {
        console.error(error);
      }
    });
  };

  const handleCustomFieldOnUpdate = (e) => {
    console.log('handleCustomFieldOnUpdate()', e);
    try {
      let cf = [...currentTicketCustomFields];
      let index = cf.findIndex((x) => x.field === e.field.field);
      cf[index] = e.result;
      setCurrentTicketCustomFields(cf);
      notification.success({ message: `${e.field.field} successfully updated` });
    } catch (error) {
      console.error(error);
      notification.error({ message: 'Failed to update' });
    }
  };

  if (!currentTicketCustomFields) return <SkeletonTable />;
  if (currentTicketCustomFields.length === 0) return <NoData />;

  return (
    <div className='flex flex-col gap-2'>
      {currentTicketCustomFields.map((field) => {
        switch (field.type) {
          case 'String':
            return <CustomFieldString ticketId={currentTicket.id} field={field} onUpdate={handleCustomFieldOnUpdate} />;
          case 'Int':
            return <CustomFieldInt ticketId={currentTicket.id} field={field} onUpdate={handleCustomFieldOnUpdate} />;
          case 'DateTime':
            return <CustomFieldDateTime ticketId={currentTicket.id} field={field} onUpdate={handleCustomFieldOnUpdate} />;
          case 'Number':
            return <CustomFieldNumber ticketId={currentTicket.id} field={field} onUpdate={handleCustomFieldOnUpdate} />;
          case 'Bool':
            return <CustomFieldBool ticketId={currentTicket.id} field={field} onUpdate={handleCustomFieldOnUpdate} />;
          case 'Select':
            return <CustomFieldSelect ticketId={currentTicket.id} field={field} onUpdate={handleCustomFieldOnUpdate} />;
          default:
            return <Alert message={`Unsupported field type: ${field.type}`} type='error' showIcon />;
        }
      })}
    </div>
  );
};

TicketCustomProperties.propTypes = {};

export default TicketCustomProperties;
